module.exports = __webpack_public_path__ + "img/banner.555226a4.jpg";